import type { CustomerStore } from '@stores/me/customer/interfaces'
import type { CustomerResponse } from '@brighterly/lib-core-types/customer/interfaces'

import routes from '@config/routes'

import { _setCustomer } from './set-customer'

export const _fetchCustomer = async (state: CustomerStore, silent: boolean): Promise<CustomerStore['customer']> => {
  if (state._inFlight) {
    return state._inFlight
  }

  const { $axios } = useNuxtApp()

  if (!silent) {
    state.status = state.customer
      ? 'ready'
      : 'loading'
  }

  state._inFlight = (async () => {
    try {
      const url = routes['me']
      const { data } = await $axios.get<CustomerResponse>(url)
      const customer = data?.data || null

      _setCustomer(state, customer)

      return state.customer

    } catch (err) {
      console.error(err)

      state.status = state.customer
        ? 'ready'
        : 'error'

      return state.customer
    } finally {
      state._inFlight = null
    }
  })()

  return state._inFlight
}
